<template lang="pug">
	//- Лог изменения кода плейабла агентом: предлагаем перезагрузить превью, чтобы применить изменения
	.ai-chat-message-content.ai-chat-code-changed
		.ai-chat-code-changed-text
			i.fa.fa-code
			span {{message.message}}
		//- Код плейабла общий для всех его версий
		.ai-chat-code-changed-warning(v-if="isCreativePlayable()")
			i.fa.fa-exclamation-triangle
			span Changing the playable code will affect all versions of this playable.
		.ai-chat-code-changed-actions
			button.btn.btn-primary.btn-sm(type="button" :disabled="!isCreativeSelected()" v-on:click="reloadPreview()" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: isCreativeSelected() ? 'Reload the preview frame' : 'Open the creative of this chat to reload its preview'}")
				i.fa.fa-refresh
				span Reload preview
</template>

<script>
	import { Creative } 			from './../../services/Creative'

	export default {
		name: "AIAgentMessageCodeChanged",
		props: ['message'],
		methods: {
			// Креатив сообщения - плейабл (код плейабла общий для всех версий)
			isCreativePlayable() {

				return Creative.getCreative(this.message["creative_id"])?.type === 'playable';

			},
			// Перезагрузка превью доступна только если открыт креатив, код которого изменил агент
			isCreativeSelected() {

				return Creative.SelectedCreative?.id === this.message["creative_id"];

			},
			// Перезагружаем фрейм превью (сброс кэша кода плейабла), чтобы применить изменения кода
			reloadPreview() {

				Broadcast.call("Refresh Iframe");

			}
		}
	}
</script>

<style lang="sass">

	.ai-chat
		.ai-chat-history
			.ai-chat-message
				// Лог изменения кода плейабла с кнопкой перезагрузки превью
				&.code-changed
					.ai-chat-code-changed
						background-color: rgba(32,168,216,0.12)
						border: 1px solid #20a8d8

					.ai-chat-code-changed-text
						display: flex
						flex-direction: row
						align-items: baseline
						gap: 8px

						i.fa
							color: #20a8d8

					.ai-chat-code-changed-warning
						display: flex
						flex-direction: row
						align-items: baseline
						gap: 8px
						margin-top: 6px
						color: #ffc107

					.ai-chat-code-changed-actions
						margin-top: 8px

						.btn i.fa
							margin-right: 6px

</style>
